import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.COMPARE_SHARING_INIT,
});

export const getSharing = id => ({
  type: types.GET_COMPARE_SHARING,
  id,
});

export const addCompareSharingTab = () => ({
  type: types.ADD_COMPARE_SHARING_TAB,
});

const { init: initRequest, fetching } = createAllActions(types.COMPARE_SHARING_SCOPE);

export { initRequest, fetching };
